import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image';
import { slugify } from '../components/slugify'
// import Img from 'gatsby-image'
var BaseHref = 'http://46.4.51.11:1337'


const JobPage = ({ data }) => (
    <div className="jobs">
        <h1>Karriere</h1>
        <div className="row">
            <div className="col-md-6 col-xs-12 left">
                    <ul>
                        <div>
                            {data.allStrapiStellenangebote.edges.map((document) => {

                                let isPublic = document.node.Public
                                let jobs

                                if ( isPublic == 0) {
                                
                                jobs = ''
                
                                } else {
                                    jobs = (
                                    <li key={document.node.id}>
                                        <h3 className="jobtitle">Zur Verstärkung unseres Teams am Arbeitsort <strong>{document.node.Job_Location}</strong> suchen wir eine/n</h3>
                                        <Link to={`/karriere/${slugify(document.node.Title)}-${slugify(document.node.Job_Location)}`}>
                                            <h2>{document.node.Title}</h2>
                                        </Link>
                                            <a href={document.node.Job_Download.publicURL} target="_blank">Download PDF</a>
                                    </li>
                                    )
                                }
                                return (
                                    jobs
                                )
                                })}
                        </div>
                    </ul>
            </div>
            <div className="col-md-6 col-xs-12 right" style={{position: "relative"}}>
                <Img
                    sizes={data.karriere.sizes}
                    style={{
                        position: "absolute",
                        left: 0,
                        bottom: 0,
                        width: "80%",
                        height: "100%"
                    }}
                />
                <div className="karriere-header">
                    <h3>Wir freuen uns über Ihre</h3>
                    <h2><a href="mailto:bewerbung@boleygeotechnik.de?subject=Initiativbewerbung">Initiativbewerbung</a></h2>
                    <h3>an <a href="mailto:bewerbung@boleygeotechnik.de?subject=Initiativbewerbung">bewerbung@boleygeotechnik.de</a></h3>
                </div>
            </div>
        </div>
    </div>
)



export default JobPage

export const SiteTitle = "Karriere"


export const RefKarriere = graphql`  
  query RefKarriereQuery { 

    karriere: imageSharp(id: {regex:"/karriere_bg/"}){
        sizes(maxWidth: 1600){
        ...GatsbyImageSharpSizes
        }
    },
    allStrapiStellenangebote(sort: { fields: [updatedAt], order: DESC }) {
      edges {
        node{
          id
          Job_Contact_Email
          Title
          Job_Location
          Public
          Job_Download{
              publicURL
          }
          }
        }
      }
    }
`


// WEBPACK FOOTER //
// ./src/pages/karriere.js